export const ProtectedRouteIndex = 'app';
